import { LitEntity, html } from '../utility/lit-entity';
import { BnModalMixin } from '../common/bn-modal-mixin';
import './tag-list';

class TagListModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.modalid = 'tag-list-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#tag-list-modal {
          --modal-min-width: 50%;
          --modal-max-width: 50%;
        }
      </style>
      <h3 slot="title">Edit Tags</h3>
      <tag-list .href="${this.href}"></tag-list>
    `;
  }
}

window.customElements.define('tag-list-modal', TagListModal);
